import P from 'components/P';
import Container from 'layouts/container/Container';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import React, { useEffect, useState } from 'react';
import LineChart from 'routes/vendorRe/components/LineChart';
import Notice from '../dashboardCard/notice/Notice';
import Manual from '../dashboardCard/manual/Manual';
import Flex from 'layouts/flex/Flex';
import OrderStatus from '../dashboardCard/statistics/OrderStatus';
import StatisticsExchangeAndRefund from '../dashboardCard/statistics/StatisticsExchangeAndRefund';
import DelayStatistics from '../dashboardCard/statistics/DelayStatistics';
import WorkSharing from '../dashboardCard/work/WorkSharing';
import { requester } from 'App';
import StoreSalesStatistics from '../dashboardCard/statistics/StoreSalesStatistics';
import OrderCalc from '../dashboardCard/order/OrderCalc';
import { useNavigate } from 'react-router-dom';
import styles from './AdminNewDashboard.module.css';
import ExpectedSettlementCard from '../dashboardCard/settlement/ExpectedSettlementCard';
import DetailedSettlementCard from '../dashboardCard/settlement/DetailedSettlementCard';

function AdminNewDashboard() {
    const [isMounted, setMounted] = useState(false);
    const [totalWeekEachAmount, setTotalWeekEachAmount] = useState();
    const [totalSalesAmount, setTotalSalesAmount] = useState();
    const [totalVerificationStats, setTotalVerificationStats] = useState(null);
    const [storeStatistics, setStoreStatistics] = useState(null);
    const [detailedStatistics, setDetailedStatistics] = useState(null); 
    const [aboveThresholdStatistics, setAboveThresholdStatistics] = useState(null);
    
    // 각 섹션별 독립적인 월 필터링을 위한 상태 추가
    const [aboveThresholdDate, setAboveThresholdDate] = useState(new Date());
    const [detailedDate, setDetailedDate] = useState(new Date());
    const [verificationDate, setVerificationDate] = useState(new Date()); // 성인인증 통계용 날짜 상태 추가
    const navigate = useNavigate();

    // 각 섹션별 월 변경 함수
    const changeAboveThresholdMonth = (amount) => {
        const newDate = new Date(aboveThresholdDate);
        newDate.setMonth(newDate.getMonth() + amount);
        setAboveThresholdDate(newDate);
    };
    
    const changeDetailedMonth = (amount) => {
        const newDate = new Date(detailedDate);
        newDate.setMonth(newDate.getMonth() + amount);
        setDetailedDate(newDate);
    };
    
    // 성인인증 통계용 월 변경 함수 추가
    const changeVerificationMonth = (amount) => {
        const newDate = new Date(verificationDate);
        newDate.setMonth(newDate.getMonth() + amount);
        setVerificationDate(newDate);
    };
    
    // 선택한 월 표시 형식
    const formatMonthYear = (date) => {
        return `${date.getFullYear()}년 ${date.getMonth() + 1}월`;
    };
    
    // 선택한 월의 시작일과 종료일 계산
    const calculateMonthRange = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth(); // 0-11
        
        // 선택한 월의 1일
        const startDate = new Date(year, month, 1);
        
        // 다음 달의 0일 (선택한 월의 마지막 날)
        const endDate = new Date(year, month + 1, 0);
        
        // 날짜 형식 변환 함수
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        
        return {
            startDate: formatDate(startDate), // YYYY-MM-DD 형식
            endDate: formatDate(endDate)      // YYYY-MM-DD 형식
        };
    };
    
    // 각 섹션별 현재 표시 중인 년월 포맷팅 (YYYY-MM)
    const aboveThresholdYearMonth = `${aboveThresholdDate.getFullYear()}-${String(aboveThresholdDate.getMonth() + 1).padStart(2, '0')}`;
    const detailedYearMonth = `${detailedDate.getFullYear()}-${String(detailedDate.getMonth() + 1).padStart(2, '0')}`;

    // 각 섹션별 필터링된 데이터
    const filteredAboveThresholdStats = aboveThresholdStatistics ? 
        aboveThresholdStatistics.filter(stat => stat.timePeriod === aboveThresholdYearMonth).slice(0, 3) : 
        [];
    
    const filteredDetailedStats = detailedStatistics ? 
        detailedStatistics.filter(stat => stat.timePeriod === detailedYearMonth).slice(0, 3) : 
        [];

    useEffect(() => {
        setMounted(true);
    }, [])

    // 성인인증 통계 데이터 가져오기 (월별)
    useEffect(() => {
        if (isMounted) {
            const dateRange = calculateMonthRange(verificationDate);
            
            let data = {
                startDate: dateRange.startDate,
                endDate: dateRange.endDate
            };
            
            requester.managerAdultVerificationStatsTotal(data, (result) => {
                if (result.code === 0) {
                    setTotalVerificationStats(result.data);
                }
            });
        }
    }, [isMounted, verificationDate]); // verificationDate가 변경될 때마다 데이터 다시 가져오기

    useEffect(() => {
        if (isMounted) {
            let storeData = { id: "123" }; //임시(나중에 인증 인가에 활용할 예정)
            requester.getWeeklyTotalSalesStatus(storeData, (result) => {
                setTotalWeekEachAmount(result.data);
            })

            let inquireData = { limit: 8 };
            requester.getStoresSalesSummary(inquireData, (result) => {
                setTotalSalesAmount(result.data);
                console.log("totalSalesAmount : ",result.data)
            })
            
            // 동적 날짜 범위 계산
            const calculateDateRange = () => {
                const now = new Date();
                // 시작 날짜: 현재로부터 1년 전 (또는 필요한 기간)
                const startDate = new Date(now);
                startDate.setFullYear(now.getFullYear() - 1);
                
                // 종료 날짜: 현재로부터 1년 후 (미래 데이터를 대비해서)
                const endDate = new Date(now);
                endDate.setFullYear(now.getFullYear() + 1);
                
                return {
                    startDate: startDate.toISOString().split('T')[0],
                    endDate: endDate.toISOString().split('T')[0]
                };
            };
            
            const dateRange = calculateDateRange();
            
            let statisticsData = {
                endDate: dateRange.endDate,
                startDate: dateRange.startDate,
                // storeId: "4000",
                timeUnit: "month"
            };
            
            console.log("데이터 조회 기간:", dateRange);
            // 미만 , 초과 실제 정산 금액
            requester.getAllDetailedStatistics(statisticsData, (result) => {
                if (result.code === 0) {
                    setDetailedStatistics(result.data);
                }
            })
            // 초과 예상 정산 금액
            requester.getAllStatisticsAboveThreshold(statisticsData, (result) => {
                if (result.code === 0) {
                    setAboveThresholdStatistics(result.data);
                }
            })

        }
    }, [isMounted])

    return (
        
            <div className={styles.container}>
                <div className={styles.flexGrid}>
                    {/* 매장별 성인인증 통계 */}
                    <div className={`${styles.flexBox} ${styles.wideBox}`}>
                    {/* <div className={styles.flexBox}> */}
                        <div className={styles.card}>
                            <div className={styles.section}>
                                <div className={styles.sectionTitle}>주간 총 매출현황</div>
                                <div className={styles.sectionContent}>
                                    <LineChart totalWeekEachAmount={totalWeekEachAmount} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 매장별 매출 현황 */}
                    <div className={styles.flexBox}>
                        <div className={styles.card}>
                            <div className={styles.section}>
                                <div className={styles.sectionTitle}>매장별 매출현황</div>
                                <div className={styles.sectionContent}>
                                    <StoreSalesStatistics totalSalesAmount={totalSalesAmount} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 스토어별 월별 정산 예정금액 */}
                    <div className={`${styles.flexBox} ${styles.wideBox}`}>
                        <ExpectedSettlementCard
                            data={aboveThresholdStatistics}
                            title="스토어별 월별 정산 예정금액"
                            navigatePath="/admin/settlement"
                        />
                    </div>
                    {/* 전체 성인인증 현황 */}
                    <div className={styles.flexBox}>
                        <div className={styles.card}>
                            <div className={styles.section}>
                                <div className={styles.sectionTitle}>
                                    <div className={styles.statsHeader}>
                                        <span>월별 전체 성인인증 현황</span>
                                        <span
                                            className={styles.moreLink}
                                            onClick={() => navigate('/admin/verificationStats')}
                                        >
                                            더보기 {'>'}
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.sectionContent}>
                                    {/* 월 선택기 */}
                                    <div className={styles.monthSelector}>
                                        <button 
                                            className={styles.monthBtn} 
                                            onClick={() => changeVerificationMonth(-1)}
                                        >
                                            &lt; 이전 달
                                        </button>
                                        <span className={styles.currentMonth}>{formatMonthYear(verificationDate)}</span>
                                        <button 
                                            className={styles.monthBtn} 
                                            onClick={() => changeVerificationMonth(1)}
                                        >
                                            다음 달 &gt;
                                        </button>
                                    </div>
                                    
                                    {totalVerificationStats ? (
                                        <div>
                                            <div className={styles.statsGrid}>
                                                <div className={styles.statItem}>
                                                    <div className={styles.statLabel}>총 시도</div>
                                                    <div className={styles.statValue}>
                                                        {totalVerificationStats.totalCount}
                                                    </div>
                                                </div>
                                                <div className={styles.statItem}>
                                                    <div className={styles.statLabel}>PASS인증</div>
                                                    <div className={`${styles.statValue} ${styles.green}`}>
                                                        {totalVerificationStats.passCount}
                                                    </div>
                                                </div>
                                                <div className={styles.statItem}>
                                                    <div className={styles.statLabel}>SMS인증</div>
                                                    <div className={`${styles.statValue} ${styles.blue}`}>
                                                        {totalVerificationStats.smsCount}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`${styles.statsGrid} ${styles.statsGridWide}`}>
                                                <div className={styles.statItem}>
                                                    <div className={styles.statLabel}>앱인증</div>
                                                    <div className={`${styles.statValue} ${styles.purple}`}>
                                                        {totalVerificationStats.appVerificationCount}
                                                    </div>
                                                </div>
                                                <div className={styles.statItem}>
                                                    <div className={styles.statLabel}>결제인증</div>
                                                    <div className={`${styles.statValue} ${styles.orange}`}>
                                                        {totalVerificationStats.paymentVerificationCount}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={styles.loading}>데이터를 불러오는 중...</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 매장별 상세 정산 금액 */}
                    <div className={`${styles.flexBox} ${styles.wideBox}`}>
                        <DetailedSettlementCard
                            data={detailedStatistics}
                            title="매장별 상세 정산 금액"
                            navigatePath="/admin/detailedSettlement"
                        />
                    </div>
                    
                    
                </div>
            </div>
        
    );
};

export default AdminNewDashboard;